import React, {useEffect, useRef, useState} from 'react';
import {DesktopDropdownItem, MobileDropdownItem} from './DropdownItems';

const DropdownMenu = (props) => {
    const {page, sitePrefix, activeClass, item_key, isMobile, menuMaker, currentPath} = props;

    const [state, setState] = useState(
        {
            open: false,
            windowWidth: 0
        });

    const menuItemRef = useRef(null);

    useEffect(() => {
        // timeoutId for debounce mechanism
        let timeoutId = null;
        const resizeListener = () => {
            // prevent execution of previous setTimeout
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => setState({...state, windowWidth: window.innerWidth}), 150);
        };

        window.addEventListener('resize', resizeListener);
        return () => {
            window.removeEventListener('resize', resizeListener);
        }
    }, [])

    useEffect(() => {
        setState({
            ...state,
            open: false
        })
    }, [currentPath])

    useEffect(() => {
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, []);

    const handleClickOutside = (event) => {
        if(menuItemRef.current && !menuItemRef.current.contains(event.target)) {
            setState({
                ...state,
                open: false
            })
        }
    }

    const toggleSubmenu = () => {
        setState({
            ...state,
            open: !state.open
        })
    }

    let displayNone = '';
    let displayBlock = '';
    if (isMobile === 1) {
        displayNone = 'none'
    }
    if (state.windowWidth < 991) {
        displayBlock = 'block'
    }
    return (
        <div className="dropdown " key={page.id} ref={menuItemRef}>
            <MobileDropdownItem open={state.open} toggleSubmenu={toggleSubmenu} title={page.title}
                                subtitle={page.subtitle} activeClass={activeClass}/>
            <div key={item_key} className={"dropdown-right dropdown dropdown-menu-sub"}
                 style={{display: state.open ? displayBlock : displayNone}}>
                {page.children.map((el) => menuMaker(el, sitePrefix, item_key, currentPath, isMobile))}
            </div>
            <DesktopDropdownItem
                toggleSubmenu={toggleSubmenu}
                activeClass={activeClass}
                title={page.title}
                subtitle={page.subtitle}/>
        </div>

    )


}


export default DropdownMenu;
